<div class="date-header" (click)="onSortClick()">
  <div class="date-header-row">
    <span class="date-header-name">{{ headerName }}</span>
    <button
      type="button"
      class="ag-header-icon ag-header-cell-filter-button"
      [class.ag-filter-active]="isFilterActive"
      [attr.aria-label]="'common.accessibility.filterColumn' | transloco: { column: headerName }"
      (click)="onFilterClick($event)">
      <span class="ag-icon ag-icon-filter" role="presentation"></span>
    </button>
    @if (isFilterActive) {
      <button
        type="button"
        class="filter-clear-btn"
        [attr.aria-label]="'common.accessibility.clearFilter' | transloco"
        (click)="onClearFilter($event)">
        <span class="ag-icon ag-icon-cross" role="presentation"></span>
      </button>
    }
  </div>
  <div class="date-meta">
    @if (sortDirection) {
      <span
        class="sort-indicator ag-icon"
        [class.ag-icon-asc]="sortDirection === 'asc'"
        [class.ag-icon-desc]="sortDirection === 'desc'"></span>
    }
  </div>
</div>
